import { render, staticRenderFns } from "./Transacctions.vue?vue&type=template&id=34dfd946&scoped=true"
import script from "./Transacctions.vue?vue&type=script&lang=js"
export * from "./Transacctions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34dfd946",
  null
  
)

export default component.exports